<div class="content-listing">
  @if (showSidebar) {
  <div class="breadcrumb">
    @if (mobileQuery?.matches) {
    <button mat-icon-button (click)="toggleSidenav()">
      <mat-icon>menu</mat-icon>
    </button>
    }
    <qa-navigation-breadcrumbs
      [navigationBreadcrumb]="navigationBreadcrumb"
    ></qa-navigation-breadcrumbs>
  </div>
  }
  <mat-drawer-container
    autosize
    class="mat-nav-container"
    [hasBackdrop]="mobileQuery?.matches ? true : false"
  >
    @if (showSidebar) {
    <mat-drawer
      #sidenav
      [opened]="!mobileQuery?.matches"
      [mode]="mobileQuery?.matches ? 'over' : 'side'"
    >
      <div class="sidebar-container">
        <div class="sidebar-header">
          <h1 class="sidebar-title">
            {{ 'common.label.content' | translate }}
          </h1>
          <p class="sidebar-content">
            {{ 'content-desc.description' | translate }}
          </p>
        </div>
        <div class="sidebar-tab">
          <mat-nav-list>
            @for (group of navGroups; track $index) { @for (item of group.items;
            track item.label) {
            <div class="tab-list" [attr.data-cy]="item.label">
              <a
                (click)="onChangeItem(item)"
                [routerLink]="item.link"
                [routerLinkActive]="item.link ? 'active' : ''"
                [routerLinkActiveOptions]="{ exact: true }"
                mat-list-item
              >
                <span mat-line
                  >{{ item.label | translate }}
                  @if (item.itemCount !== undefined && item.itemCount !== null)
                  {
                  <span>({{ item.itemCount }})</span>
                  }</span
                >
              </a>
            </div>
            } }
          </mat-nav-list>
        </div>
      </div>
    </mat-drawer>
    }
    <mat-drawer-content>
      <div class="tab-container">
        <router-outlet></router-outlet>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
